export var InfoTooltipIconType;
(function (InfoTooltipIconType) {
    InfoTooltipIconType["Warning"] = "warning";
    InfoTooltipIconType["Info"] = "info";
    InfoTooltipIconType["Payment"] = "payment";
})(InfoTooltipIconType || (InfoTooltipIconType = {}));
